require("!!/tmp/build_09b76a25/node_modules/script-loader/addScript.js")(require("!!/tmp/build_09b76a25/node_modules/raw-loader/index.js!/tmp/build_09b76a25/node_modules/tinymce/plugins/textcolor/plugin.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/tinymce/plugins/textcolor/plugin.js
// module id = 273
// module chunks = 2